import { render, staticRenderFns } from "./image-modal.vue?vue&type=template&id=1bee7b28"
import script from "./image-modal.vue?vue&type=script&lang=js"
export * from "./image-modal.vue?vue&type=script&lang=js"
import style0 from "./image-modal.vue?vue&type=style&index=0&id=1bee7b28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports